import React from "react";

import portrait from "../images/circle-portrait.png";

export default class Home extends React.Component {
    constructor () {
        super();
        this.renderHome = this.renderHome.bind(this);
    }

    renderHome = () => {
        if (this.props.isBrowser === 1) {
            return (
                <div className="secondary-header">
                    <div className="secondary-header-wrapper">
                        <div className="floating-text">
                            <h1>Mechanical Engineer</h1>
                            <br></br>
                            <h1>Web Developer</h1>
                        </div>
                        <div className="display-picture">
                            <img src={portrait} width="350px"  alt="Self Portrait"></img>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="mobile-secondary-header">
                    <div className="mobile-secondary-header-wrapper">
                        <h1 className="mobile-home-text">Mechanical Engineer</h1>
                        <br></br>
                        <h1 className="mobile-home-text">Web Developer</h1>
                        <img src={portrait} width="60%" alt="Self Portrait"></img>
                    </div>
                </div>
            );
        }
    }

    render() {
        return this.renderHome();
    }
}


// WEBPACK FOOTER //
// ./src/components/Home.js